import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router-dom'

import { dmsState } from '@/app/store'
import { Loader } from '@/shared'
import { routes } from '@Config/config'

import { Item } from './Item/Item'
import style from './List.module.scss'

export const List = observer(() => {
    const navi = useNavigate()

    const headers = ['ИНН', 'Наименование компании', 'Страхователи']

    if (!dmsState.insuredsList || !dmsState.companiesList) {
        return <Loader className={style.loader} />
    }

    return (
        <div className={style.container}>
            <div className={style.addCompany}>
                <button className={style.btn} onClick={() => navi(`${routes.DMSM}/companies/addCompany`)}>
                    Добавить компанию
                </button>
            </div>
            <div className={style.headerLineWrapper}>
                {headers.map((title) => (
                    <div key={title} className={style.headerLine}>
                        <div className={style.headerCell}>
                            <span>{title}</span>
                        </div>
                    </div>
                ))}
            </div>
            {dmsState.companiesList.map((line) => (
                <Item key={line.id} {...line} />
            ))}
        </div>
    )
})
